// LE NOM DE CET APPAREIL, pour le seul compteur de débit du serveur.
//
// POURQUOI IL EXISTE (12/10/2026). `backend/rate_limit.py` comptait les
// requêtes coûteuses PAR ADRESSE IP. Le Manoir sortira sur Internet par
// Starlink : toutes les suites, la borne du hall et les téléphones des invités
// derrière UNE adresse. Le banc du hall l'a chiffré — neuf invités, une IP :
// vingt-quatre questions sur vingt-sept refusées d'un « Doucement, voyageur ».
// Le serveur compte désormais par APPAREIL, et c'est ce nom qui le lui dit.
//
// CE QU'IL N'EST PAS :
//   · une preuve. N'importe qui peut en envoyer un autre ; le serveur le sait
//     et garde un plafond par réseau derrière (voir l'en-tête du module
//     Python). Il ne sert à rien d'autre qu'à départager les invités d'un même
//     réseau, et rien ne doit jamais s'y fier pour décider d'un droit.
//   · un identifiant de session ni de salon. Il ne touche pas
//     `pairingSession.js` — un salon ne se frappe qu'au serveur
//     (`unSalonNeSeFrappeQuAuServeur.test.js`).
//   · un traceur. Il ne quitte que vers notre propre serveur, qui ne
//     l'écrit ni en base ni dans ses journaux : il n'existe que dans la
//     mémoire du compteur de débit, dont les traces expirent en une minute
//     et dont les seaux inactifs sont balayés (`rate_limit.py`).
//
// POURQUOI localStorage : un nom qui changerait à chaque onglet ouvrirait un
// seau neuf par onglet. Si le stockage est refusé (navigation privée, iframe
// sans stockage), le nom vit le temps de la page — jamais d'exception.
//
// OÙ IL S'ÉCRIT : au premier envoi par `medardApi.js` — l'app, et aussi la
// touche « Écouter » d'une fiche du site public. Il est donc déclaré, surface
// « site », dans `COLLECTE_MESUREE` (`mentionsLegales.js`).

export const CLIENT_KEY_HEADER = 'X-Medard-Client';

const CLIENT_KEY_STORAGE = 'medard.clientKey';
// La forme que le serveur accepte (`_CLIENT_KEY_SHAPE`, 16 à 64 caractères
// base64url). Une valeur stockée qui ne l'a pas — un stockage corrompu, une
// ancienne version — est remplacée plutôt que renvoyée pour rien.
const SHAPE = /^[A-Za-z0-9_-]{16,64}$/;

let memo = null;

function base64url(bytes) {
    let s = '';
    for (const b of bytes) s += String.fromCharCode(b);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function fresh() {
    const bytes = new Uint8Array(16);
    const c = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
    if (c && typeof c.getRandomValues === 'function') {
        c.getRandomValues(bytes);
    } else {
        // Ce n'est pas un secret : un aléa ordinaire suffit à départager deux
        // appareils, et un navigateur sans `crypto` ne doit pas rester muet.
        for (let i = 0; i < bytes.length; i += 1) bytes[i] = Math.floor(Math.random() * 256);
    }
    return base64url(bytes);
}

/** Le nom de cet appareil — tiré une fois, gardé, jamais d'exception. */
export function clientKey() {
    if (memo) return memo;
    try {
        const stored = window.localStorage.getItem(CLIENT_KEY_STORAGE);
        if (stored && SHAPE.test(stored)) {
            memo = stored;
            return memo;
        }
    } catch {
        /* stockage refusé : le nom vivra le temps de la page */
    }
    memo = fresh();
    try {
        window.localStorage.setItem(CLIENT_KEY_STORAGE, memo);
    } catch {
        /* idem */
    }
    return memo;
}

/** `{ 'X-Medard-Client': <nom> }`, à fusionner dans les en-têtes d'une requête. */
export function clientKeyHeader() {
    return { [CLIENT_KEY_HEADER]: clientKey() };
}

/** Pour les tests : oublie le nom mémorisé (le stockage, lui, est intact). */
export function resetClientKeyForTests() {
    memo = null;
}
